export default import.meta.ROLLUP_FILE_URL_o98ZNTO4qETQ77W5$JIRZQ